/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Model Interface */
import { AiFunctionCall } from '@rappider/rappider-sdk';

/* Actions */
import * as AiFunctionCallActions from './ai-function-call.actions';

/* State key */
export const featureKey = 'aiFunctionCall';

/* State interface */
export interface State {
  data: AiFunctionCall[] | null;
  isLoading: boolean;
  loaded?: boolean;
  error: any;
}

/* Initial values */
export const initialState: State = {
  data: null,
  isLoading: false,
  loaded: false,
  error: null
};

/* Function to calculate updated aiFunctionCall optimistically */
function updateAiFunctionCalls(
  updatedAiFunctionCallId: string,
  updatedAiFunctionCallData: Partial<AiFunctionCall>,
  allAiFunctionCalls: AiFunctionCall[]): AiFunctionCall[] {
  if (allAiFunctionCalls?.length) {
    const updatedAiFunctionCall: AiFunctionCall = allAiFunctionCalls?.find(aiFunctionCall =>
      aiFunctionCall.id === updatedAiFunctionCallId) || <AiFunctionCall>{};
    const updatedAiFunctionCallWithNewData = <AiFunctionCall>{ ...updatedAiFunctionCall, ...updatedAiFunctionCallData };
    const updatedAiFunctionCalls: AiFunctionCall[] = [
      ...allAiFunctionCalls.filter(aiFunctionCall => aiFunctionCall.id !== updatedAiFunctionCallId),
      updatedAiFunctionCallWithNewData
    ];
    return updatedAiFunctionCalls;
  } else {
    return <AiFunctionCall[]>[];
  }
}

export const reducer = createReducer(
  initialState,
  on(AiFunctionCallActions.GetAiFunctionCallsSuccessful, (state, action) => ({
    ...state,
    data: action.payload.aiFunctionCalls,
    loaded: true,
  })),
  on(AiFunctionCallActions.CreateAiFunctionCall, (state) => ({
    ...state,
    isLoading: true
  })),
  on(AiFunctionCallActions.CreateAiFunctionCallSuccessful, (state, action) => ({
    ...state,
    data: [
      ...state.data ?? [],
      action.payload.newEntity
    ],
    isLoading: false,
  })),
  on(AiFunctionCallActions.CreateAiFunctionCallFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(AiFunctionCallActions.UpdateAiFunctionCall, (state) => ({
    ...state,
    isLoading: true
  })),
  on(AiFunctionCallActions.UpdateAiFunctionCallSuccessful, (state, action) => ({
    ...state,
    data: updateAiFunctionCalls(action.payload.id, action.payload.updatedData, (state.data?.length ? state.data : [])),
    isLoading: false
  })),
  on(AiFunctionCallActions.UpdateAiFunctionCallFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(AiFunctionCallActions.DeleteAiFunctionCall, (state) => ({
    ...state,
    isLoading: true
  })),
  on(AiFunctionCallActions.DeleteAiFunctionCallSuccessful, (state, action) => ({
    ...state,
    data: state?.data?.filter(item => action.payload.id !== item.id) ?? [],
    isLoading: false
  })),
  on(AiFunctionCallActions.DeleteAiFunctionCallFailure, (state) => ({
    ...state,
    isLoading: false
  })),

  on(AiFunctionCallActions.ResetStateToInitial, () => initialState)
);
